// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uSTs","index":"styles_index__3_2jN"};